import { CollectionFieldSchema } from '@candu-ai/collections/types';
import { BuiltInComponents } from 'craft/constants';
import { CollectionTargetLocation } from 'craft/types';

export const getAllowedFields = (
  type: string | undefined,
  availableFields: Record<string, CollectionFieldSchema[]>,
): Record<string, CollectionFieldSchema[]> => {
  const setIfExists = (
    targetLocation: CollectionTargetLocation,
  ): Record<string, CollectionFieldSchema[]> => {
    const field = availableFields[targetLocation];
    if (!field || field.length === 0) {
      return {};
    }
    return { [targetLocation]: field };
  };

  if (type === BuiltInComponents.Image) {
    return setIfExists(CollectionTargetLocation.Image);
  }

  if (type === BuiltInComponents.Button) {
    return {
      ...setIfExists(CollectionTargetLocation.ActionURL),
      ...setIfExists(CollectionTargetLocation.Text),
    };
  }

  if (type === BuiltInComponents.Image) {
    return setIfExists(CollectionTargetLocation.Image);
  }

  if (type === BuiltInComponents.Text || type === BuiltInComponents.Typography) {
    return setIfExists(CollectionTargetLocation.Text);
  }

  if (type === BuiltInComponents.Card) {
    return setIfExists(CollectionTargetLocation.ActionURL);
  }

  return {};
};
